import { Injectable } from '@angular/core';
import { DataApiService } from '../Services/data-api.service';
import { HttpClient } from '@angular/common/http';
import { AlertComponent } from '../components/dialogs/alert/alert.component';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})

export class MapsService {

  constructor(
    private dataApi: DataApiService,
    private http: HttpClient,
    private dialog: MatDialog,
  ) { }

  //precios
  public precioBase = null;
  public precio_recojo_entrega = null;
  public precio_oficina_recojo = null;
  public precioCargoNocturno = null;
  public horaCargoNocturnoInicio = null;
  public horaCargoNocturnoFinal = null;
  public charge = 0;
  public chargeSoloAdmin = 0;
  public direccionOficina = 'Cra 2 # 65-7, Comuna 5, Cali, Valle del Cauca, Colombia';
  public precioTramite= null;
  public region: number = Number(localStorage.getItem("region"));

  public getChoords: any = this.coordenadasSegunRegion(this.region);


  coordenadasSegunRegion(region: number) {

    if (region == 0) {
      return { lat: 3.418888983011398, lng: -76.53218708207842 }
    } else if (region == 1) {
      return { lat: 3.5381204230824777, lng: -76.29806429426874 }
    } else if (region == 2) {
      return { lat: 3.8979729531528844, lng: -76.30024733958255 }
    } else if (region == 3) {
      return { lat: 3.5834978594806093, lng: -76.49227095974837 }
    }else if (region == 4) {    
      return { lat: 10.995730157487278, lng: -74.8110410518547}
    }else if (region == 5) {    
      return { lat:  4.708537501606656, lng: -74.07170630630738 }
    }
  }


  preciosPedido(): void {
    this.http.get(this.dataApi.url + "/showPrices").subscribe((data) => {
      this.precioBase = data["precioBase"];
      this.precio_recojo_entrega = data["precioRecorrido"];
      this.precio_oficina_recojo = data["precioARecojo"];
      this.horaCargoNocturnoInicio = data["horaCargoNocturno"];
      this.horaCargoNocturnoFinal = data["horaCargoNocturnoFinal"];
      this.precioCargoNocturno = data["precioCargoNocturno"];
      this.chargeSoloAdmin = this.precioCargoNocturno;
      this.precioTramite = data["precioTransferencia"];
    })
  }
  

  calculatePrize(oficinaARecojo: any, routes: any) {
    let precioDistanciaRecorrida:number = 0;
    let distance:number = 0;

    const points = [];
    points[0] = {
      distanceKM: oficinaARecojo.routes[0].legs[0].distance.value / 1000,
      price: (oficinaARecojo.routes[0].legs[0].distance.value / 1000) * this.precio_oficina_recojo
    };
    for (let i = 0; i < routes.length; i++) {
      points[i + 1] = {
        distanceKM: routes[i].distance.value / 1000,
        price: Number(((routes[i].distance.value / 1000) * this.precio_recojo_entrega).toFixed(2))
      };
      precioDistanciaRecorrida += Number(((routes[i].distance.value / 1000) * this.precio_recojo_entrega).toFixed(2));
      distance += routes[i].distance.value / 1000;
    }

    return {
      precioBase: this.precioBase,
      points: points,
      distance: distance.toFixed(2) + "km",
      precioDistanciaRecorrida:precioDistanciaRecorrida,
      precioCargoNocturno:this.precioCargoNocturno, 
      horaCargoNocturnoInicio: this.horaCargoNocturnoInicio,
      horaCargoNocturnoFinal: this.horaCargoNocturnoFinal,
      precioTramite : this.precioTramite
    }

  }
 

  


  alertForm() {
    this.dialog.open(AlertComponent, {
      width: "200px",
      panelClass: "alert-dialog-container",
      data: { mensaje: "Por favor, rellenar todos los campos." },
      disableClose: true, autoFocus: true
    });
  }

}
